import React from 'react';

interface Slide {
    imageUrl: string;
    imageAlt?: string;
    title: string;
    subtitle: string;
    listing?: string[];
}

interface ImageTextSliderProps {
    title: string;
    slides: Slide[];
}

const ImageTextSlider: React.FC<ImageTextSliderProps> = ({ slides, title }) => {

    return (
        <section className="w-full max-w-6xl mx-auto px-4 py-12">
            <h2 className="text-3xl font-bold text-textColor mb-4">{title}</h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
                {slides.map((member, idx) => (
                    <div key={idx} className="flex flex-col items-center text-center">
                        <img
                            src={member.imageUrl}
                            alt={member.imageAlt || `Teammitglied ${idx + 1}`}
                            loading="lazy"
                            className="rounded-lg object-cover w-auto max-w-[227px] mb-4 shadow"
                        />
                        <small className="text-md text-textColor">{member.subtitle}</small>
                        <h3 className="text-xl font-bold text-textColor mb-2">{member.title}</h3>

                        {member.listing && (
                            <ul className="list-disc list-inside text-gray-700 text-sm">
                                {member.listing.map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
};

export default ImageTextSlider;
